import { BroadcastIcon } from "@phosphor-icons/react";
import { getInstanceStatusColor } from "../helpers/helper";
import { Flex, Typography } from "antd";
import { useAntTheme } from "hooks/useAntTheme/";
import { useTranslate } from "hooks/useTranslate/";
import { InstanceStatus } from "./types";

const statusMessages = {
  Initial: "media.components.ProjectVideo.statusMessages.gettingReady",
  Draft: "media.components.ProjectVideo.statusMessages.gettingReady",
  Pending: "media.components.ProjectVideo.statusMessages.gettingReady",
  Generating: "media.components.ProjectVideo.statusMessages.generating",
  Error: "media.components.ProjectVideo.statusMessages.error",
  Generated: "media.components.ProjectVideo.statusMessages.readyToPublish",
};

// isLive (publication status, MED-6885) takes priority over the media
// generation status — the instance can be live regardless of its media.
const getStatusMessage = (status: InstanceStatus, isLive: boolean) => {
  if (isLive) return "media.components.ProjectVideo.statusMessages.live";
  return (
    statusMessages[status] ??
    "media.components.ProjectVideo.statusMessages.default"
  );
};

export const InstanceStatusMessage = ({
  status,
  isLive,
}: {
  status: InstanceStatus;
  isLive: boolean;
}) => {
  const { theme } = useAntTheme();
  const t = useTranslate();

  const statusMessage = getStatusMessage(status, isLive);

  return (
    <Flex align="center" gap={8}>
      <BroadcastIcon
        size={25}
        style={{
          color: getInstanceStatusColor(status, isLive),
        }}
      />
      <Typography.Text
        style={{
          fontSize: "16px",
          color: theme.colorTextBaseRedesign,
          fontWeight: 400,
          letterSpacing: "-0.48px",
        }}
      >
        {t("media.components.ProjectVideo.status", {
          statusMessage: t(statusMessage),
        })}
      </Typography.Text>
    </Flex>
  );
};
